<template>
	<div ref="hand" v-parallax-fit="parallax" class="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/16_MovingHand@2x.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/ozzie/2.srt',
				'es': '/themes/rise-theme/resources/assets/audio/ozzie/2_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 17000,
					end: 20000,
					fromStyle: { transform: 'translateX(500%)' },
					toStyle: { transform: 'translateX(0%)' },
					easing: 'linear'
				},
				{
					start: 20500,
					end: 22000,
					fromStyle: { transform: 'translateX(0%)' },
					toStyle: { transform: 'translateX(510%)' },
					easing: 'linear'
				}
			]
		}
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/ozzie/OZZIE_PART3_010723.mp3';

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(0%)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					this.$evidence.value = null;
					this.$readMore.value = '';
				}
			});
		});

		this.mutationObserver.observe(this.$refs.hand, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.hand {
	position: absolute;
	left: 100%;
	bottom: 0;
	min-width: 800px;
	margin-left: -50px;
	margin-bottom: -90px;
	transition: all 0.8s linear;
}

@media screen and (max-width: 991px) {
	.hand {
		min-width: 600px;
		margin-left: -30px;
		margin-bottom: -81px;
	}
}

@media screen and (max-width: 650px) {
	.hand {
		min-width: 390px;
		margin-left: -29px;
		margin-bottom: -58px;
	}
}
</style>
